export default (ngModule) => {

  ngModule
    .directive('scrollControll', function scrollControll(ScrollControl) {
      return {
        restrict: 'A',
        link: link
      };

      function link(scope, elem) {
        setTimeout(init, 0);

        function init() {
          elem[0].scrollTop = ScrollControl.getPosition();
          elem.bind('scroll', handler);
          scope.$on('$destroy', () => elem.unbind('scroll', handler));
        }

        function handler() {
          ScrollControl.setPosition(elem[0].scrollTop);
        }
      }
    });
};



/** WEBPACK FOOTER **
 ** ./common/decorators/scroll-control/scroll-control.directive.ts
 **/